import * as React from "react";
import {getAmountToDisplay} from "../../CommonFunctions";
import {Link} from "react-router-dom";
import {
    AnnualPolicyInfo, ProductsEnum,
    D_MMM_YYYY_DATE_FORMAT, resourcesHelper,
} from "@falcon/services";
import * as moment from "moment";

interface IProps {
    interaction: any;
    policyInfo: AnnualPolicyInfo;
    amount?: number;
    reuseCard?: boolean
}

export class LackOfFoundsDelinquencyBanner extends React.Component<IProps, any> {

    public render() {
        const {interaction, policyInfo} = this.props;

        const delinquencyStartDate = moment.utc(policyInfo.delinquencyStartDate ?? "", moment.ISO_8601);
        if (!delinquencyStartDate.isValid()) {
            throw new Error('Invalid date format');
        }

        const today = moment().startOf('day');
        const plus6Days = moment(delinquencyStartDate).add(6, 'days');
        const plus7Days = moment(delinquencyStartDate.add(7, 'days'));
        const plus21Days = moment(delinquencyStartDate.add(21, 'days'));

        if (today.isBefore(plus6Days)) {
            const formattedSecondPaymentAttemptDate:string = plus7Days.format(D_MMM_YYYY_DATE_FORMAT);
            const policyProduct: ProductsEnum = interaction.product;

            return this.getFirstMissedPaymentBanner(formattedSecondPaymentAttemptDate, policyProduct);
        } else if (today.isBetween(plus6Days, plus21Days)) {
            const formattedCancellationDate:string = delinquencyStartDate.format(D_MMM_YYYY_DATE_FORMAT);
            return this.getSecondMissedPayment(interaction.product, formattedCancellationDate);
        } else {
            return this.getLastMissedPayment(interaction.product);
        }
    }

    private getFirstMissedPaymentBanner(formattedSecondPaymentAttemptDate: string, policyProduct: ProductsEnum): React.ReactNode {
        return <div className="banner dashboard-missed-payment-banner">
            <div className="banner-text" id={"firstMissedPayment"}>
                <p className="font-weight-bold">We didn't receive payment for your {resourcesHelper.PRODUCT} {policyProduct === ProductsEnum.HOME ? "Home" : "Car"} Insurance policy this month.</p>
                <p>You can <Link id={"payNow-inline"} className="text-decoration-underline cursor-pointer muli-bold-16"
                                 state={{verifyCardFailed: false, product: policyProduct}}
                                 to={`/dashboard/account/${this.props.reuseCard ? "payOverdueInstalment" : "missedPolicyPayment"}/${this.props.interaction.agreementNumber}`}>{'pay now, '}</Link>
                    or we'll try the payment again{' '}
                    on the <span className="font-weight-bold">{formattedSecondPaymentAttemptDate}</span>.{' '}
                    If payment on the <span className="font-weight-bold">{formattedSecondPaymentAttemptDate}</span> is
                    unsuccessful and you don't pay by {' '}
                    <span className="font-weight-bold">{formattedSecondPaymentAttemptDate}</span> we may pass it to a debt collection
                    agency and this may impact your credit rating.
                    <Link id={"payNow"} className="text-decoration-underline cursor-pointer muli-bold-16"
                          state={{verifyCardFailed: false, product: policyProduct}}
                          to={`/dashboard/account/${this.props.reuseCard ? "payOverdueInstalment" : "missedPolicyPayment"}/${this.props.interaction.agreementNumber}`}>{'Pay ' + getAmountToDisplay(this.props.amount) + ' now'}</Link>
                </p>
            </div>
        </div>
    }

    private getSecondMissedPayment(policyProduct: ProductsEnum,
                                                         formattedCancellationDate: string): React.ReactNode {
        return <div className="banner dashboard-missed-payment-banner">
            <div className="banner-text" id={"secondMissedPayment"}>
                <p className="font-weight-bold">We didn't receive payment for your {resourcesHelper.PRODUCT} {policyProduct === ProductsEnum.HOME ? "Home" : "Car"} Insurance policy this month.</p>
                <p>You can <Link id={"payNow-inline"} className="text-decoration-underline cursor-pointer muli-bold-16"
                                 state={{ verifyCardFailed: false, product: policyProduct }}
                                 to={`/dashboard/account/${this.props.reuseCard ? "payOverdueInstalment" : "missedPolicyPayment"}/${this.props.interaction.agreementNumber}`}>{'Pay now. '}</Link>
                    If you don't pay by {' '}
                    <span className="font-weight-bold">{formattedCancellationDate}</span> we may pass it to a debt collection agency
                    and this may impact your credit rating.
                </p>
                <Link id={"payNow"} className="text-decoration-underline cursor-pointer muli-bold-16"
                      state={{ verifyCardFailed: false, product: policyProduct }}
                      to={`/dashboard/account/${this.props.reuseCard ? "payOverdueInstalment" : "missedPolicyPayment"}/${this.props.interaction.agreementNumber}`}>{'Pay ' + getAmountToDisplay(this.props.amount) + ' now'}</Link>
            </div>
        </div>
    }

    private getLastMissedPayment(policyProduct: ProductsEnum): React.ReactNode {
        return <div className="banner dashboard-missed-payment-banner">
            <div className="banner-text" id={"secondMissedPayment"}>
                <p className="font-weight-bold">We didn't receive payment for your {resourcesHelper.PRODUCT} {policyProduct === ProductsEnum.HOME ? "Home" : "Car"} Insurance policy.</p>
                <p>You can <Link id={"payNow-inline"} className="text-decoration-underline cursor-pointer muli-bold-16"
                                 state={{ verifyCardFailed: false, product: policyProduct }}
                                 to={`/dashboard/account/${this.props.reuseCard ? "payOverdueInstalment" : "missedPolicyPayment"}/${this.props.interaction.agreementNumber}`}>{'Pay now. '}</Link>
                </p>
            </div>
        </div>
    }
}
